// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__2iC6o","title":"FrontImage_title__2dxVY"};